import clsx from 'clsx';
import React, { ForwardedRef, ReactNode } from 'react';

import styles from './Button.module.scss';

type Props = React.ButtonHTMLAttributes<any> & {
  keepColorWhenDisabled?: boolean;
};

const Button = (
  { keepColorWhenDisabled, className, children, ...otherProps }: Props,
  ref: ForwardedRef<any>,
): ReactNode => (
  <button
    {...otherProps}
    className={clsx(className, styles.button, !keepColorWhenDisabled && styles.greyWhenDisabled)}
    ref={ref}
  >
    {children}
  </button>
);

export default React.forwardRef(Button);
